import { zSidLabel } from "src/types";
import { z } from "zod";

import { zObjectExtensionBinding } from "../extensionBindings/ZExtensionBinding";
import { zRoleAccess } from "../permissions/ZRoleAccess";
import { zSysDataHistory } from "../sysData/ZSysData";

const zCatalogClassifierItem = z.object({
  id: z.string(),
  displayId: z.number(),
  name: z.string(),
  counter: z.number().nullish(),
  description: z.string().nullish(),
});
export type ZCatalogClassifierItem = z.infer<typeof zCatalogClassifierItem>;

const zCatalogActionCreate = z.object({
  type: z.literal("create"),
  disabled: z.boolean(),
});
const zWfCatalogActionCreate = z.object({
  type: z.literal("workflowCreate"),
  disabled: z.boolean(),
  workflowId: z.string(),
});

export type ZCatalogActionCreate = z.infer<typeof zCatalogActionCreate>;
export type ZWfCatalogActionCreate = z.infer<typeof zWfCatalogActionCreate>;

export const zCatalogAction = z.discriminatedUnion("type", [
  zCatalogActionCreate,
  zWfCatalogActionCreate,
]);
export type ZCatalogAction = z.infer<typeof zCatalogAction>;

export const zCatalog = z.object({
  id: z.string(),
  displayId: z.number(),
  name: z.string(),
  description: z.string().nullish(),
  schema: zSidLabel,
  classifiers: zCatalogClassifierItem.array().nullish(),
  displayAttribute: zSidLabel.optional(),
  permissions: zRoleAccess
    .array()
    .nullish()
    .describe("Права доступа для ролей"),
  actions: zCatalogAction
    .array()
    .nullish()
    .describe(
      "Список действий, которые можно выполнить на странице записей каталога",
    ),
  extensions: zObjectExtensionBinding.array().nullish(),
  ...zSysDataHistory.shape,
});
export type ZCatalog = z.infer<typeof zCatalog>;

export type CatalogFilters = {};
